export const cartFormatter = ({cart}) => {
    const products =
        cart?.productItems?.map((line, i) => ({
            product_id: line?.productId,
            name: line?.productName,
            price: Number(line?.price || 0),
            quantity: line?.quantity || 1,
            position: i + 1
        })) || []

    return {
        cart_id: cart?.basketId,
        currency: cart?.currency,
        products,
        value: Number(cart?.orderTotal || 0)
    }
}

export const productAddedFormatter = (event) => {
    const {properties} = event

    if (!properties) return {}

    return {
        cart_id: properties.cart_id,
        total: properties.total,
        value: properties.value,
        currency: properties.currency,
        sku: properties.sku,
        product_id: properties.product_id,
        price: properties.price,
        name: properties.name,
        quantity: properties.quantity,
        items:
            properties.items?.map((item) => ({
                product_id: item.product_id,
                sku: item.sku,
                name: item.name,
                price: item.price,
                quantity: item.quantity,
                variant: item.variant,
                image_url: item.image_url,
                product_url: item.product_url
            })) || []
    }
}

export const checkoutStartedFormatter = (event) => {
    const {properties} = event

    if (!properties) return {}

    return {
        cart_id: properties.cart_id,
        currency: properties.currency,
        value: properties.value,
        products:
            properties.products?.map((product) => ({
                product_id: product.product_id,
                name: product.name,
                sku: product.sku,
                price: product.price,
                quantity: product.quantity,
                variant: product.variant
            })) || []
    }
}
